import React from "react";
import { CategoryBreakdown } from "./DessertsBreakdown";

// Warm, bakery-oven palette — distinguishes pastry rows from the sage/olive
// dessert palette when both pies sit on the same dashboard.
const PASTRY_COLOURS = [
  "#B98A50", "#D9A066", "#E3B784", "#F0D2A2", "#A56A2C",
  "#7C4F1E", "#C48A44", "#8D5A2C", "#EABE7C", "#B57C3B",
];

/**
 * Pastry sales breakdown — mirror of DessertsBreakdown but wired to the
 * Pastry category. POS commit auto-tags any name matching the pastry
 * keyword list (danish / croissant / cruffin / pain au / brioche / scone /
 * muffin / cinnamon roll / tart / focaccia / kouign) so this pie populates
 * automatically. Admin can also force a row via "+ Create as Pastry" on
 * the POS review screen.
 *
 * No reclassify button here — pastry uses the per-item keyword classifier
 * on POS commit, not the strict Desserts allow-list, so there's nothing to
 * bulk-migrate.
 */
export default function PastryBreakdown() {
  return (
    <CategoryBreakdown
      category="Pastry"
      headline="Danish · Croissant · Cruffin · Scone · Muffin · by flavour"
      testidPrefix="sales-pastry"
      colours={PASTRY_COLOURS}
      emptyBody={<>
        Upload your GEBME export in <strong className="text-ink">Import from POS</strong>. Pastry
        names (danish, croissant, cruffin, scone, muffin, cinnamon roll, tart, brioche…) are
        auto-tagged <strong className="text-ink"> Category = Pastry</strong> on commit and land here.
      </>}
      emptyHint={<>
        A row not landing here? Re-upload and pick <strong>+ Create as Pastry</strong> on the review
        screen to force the classification.
      </>}
    />
  );
}
